import Layout from '@/views/layout'

export default [
  {
    path: '/gasStationManage',
    name: 'gasStationManage',
    redirect: '/gasStationManage/gasStationInfo',
    component: Layout,
    meta: {
      title: '油站管理',
      icon: 'gas.png',
      index: 11
    },
    children: [
      {
        path: 'gasStationInfo',
        name: 'gasStationInfo',
        // componentName: 'gasStationManage_gasStationInfo',
        meta: {
          title: '油站信息',
          id: '1621476523'
        },
        component: () => import('@/views/gasStationManage/gasStationInfo')
      },
      {
        path: 'gasDetail',
        name: 'gasDetail',
        // componentName: 'gasStationManage_gasDetail',
        hidden: true,
        meta: {
          title: '油站详情'
        },
        component: () => import('@/views/gasStationManage/gasStationInfo/detailPage')
      },
      {
        path: 'modifyLog',
        name: 'modifyLog',
        hidden: true,
        meta: {
          title: '油站信息'
        },
        component: () => import('@/views/gasStationManage/gasStationInfo/modifyLog')
      },
      {
        path: 'oilPriceManage',
        name: 'oilPriceManage',
        componentName: 'gasStationManage_oilPriceManage',
        meta: {
          title: '油价管理',
          id: '1621476533',
        },
        component: () => import('@/views/gasStationManage/oilPriceManage')
      },
      {
        path: 'gasGunManage',
        name: 'gasGunManage',
        componentName: 'gasStationManage_gasGunManage',
        meta: {
          title: '油枪管理',
          id: '1621476586',
          trackName: '油枪管理（查询'
        },
        component: () => import('@/views/gasStationManage/oilGunManage')
      },
      {
        path: 'openTime',
        name: 'openTime',
        componentName: 'gasStationManage_openTime',
        meta: {
          title: '营业时间',
          id: '1621476591'
        },
        component: () => import('@/views/gasStationManage/openTime')
      },
      {
        path: 'openTime_record',
        name: 'openTime_record',
        hidden: true,
        meta: {
          title: '营业时间'
        },
        component: () => import('@/views/gasStationManage/openTime/record')
      }
    ]
  }
]